<div class="vtr-widget-system-update">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="title" id="widget-system-update-title" role="text">{{'systemUpdates.title' | translate}}</div>
				<div class="description"
					id="widget-system-update-description"
					role="text"
					[dir]="'dir' | translate"
					[innerHTML]="'dashboard.systemUpdate.subtitle' | translate"></div>
				<div class="button-box">
					<vtr-ui-button linkId="btn-check-for-system-updates"
						buttonColor="outline"
            [isFullWidth]="true"
            (onClick)="gotoAndCheckSystemUpdate()"
						[label]="'dashboard.systemUpdate.checkForSystemUpdates' | translate"></vtr-ui-button>
				</div>
			</div>
		</div>
	</div>
</div>
